import React from 'react'

const ImportIframe = ({ src, height }) => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', width: '100%' }}>
      <iframe
        style={{ border: 'none' }}
        id="sf-${formId}"
        src={src}
        width="100%"
        height={height}
        scrolling="no"
        frameBorder="0"
      ></iframe>
    </div>
  )
}

export default ImportIframe
